var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 90C45.1125 90 33 77.8875 33 63C33 48.1125 45.1125 36 60 36C74.8875 36 87 48.1125 87 63C87 77.8875 74.8875 90 60 90ZM60 42C48.42 42 39 51.42 39 63C39 74.58 48.42 84 60 84C71.58 84 81 74.58 81 63C81 51.42 71.58 42 60 42Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18H21V99H27V18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45H12V18H18V39H30V18H36V45Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 98.9999H93V18L98.8725 17.1375L107.003 44.2349C107.82 46.9599 107.29 49.9449 105.582 52.2199L99 60.9974V98.9999ZM99 38.4399V50.9999L100.783 48.6224C101.353 47.8649 101.527 46.8674 101.255 45.9599L99 38.4399Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.4cb2db0f.svg";
export { ForwardRef as ReactComponent };